export const modalErrorEvLabel = (code?: string | number) => {
  if (!code) return "Poxa, nosso sistema está indisponível no momento";
  switch (code.toString()) {
    case "400":
      return "Falha na conexão";
    case "401":
      return "Sessão expirada";
    case "402":
      return "Erro ao processar o pagamento";
    case "408":
      return "Sessão expirada";
    case "415":
      return "Tipo de mídia não suportado";
    default:
      return "Poxa, nosso sistema está indisponível no momento";
  }
};
